const production = true;

export const domainName = production
  ? "https://zongstartalks.com.pk"
  : "https://zongstartalks.ecnstg.com";

export const baseUrl = `${domainName}/startalk/api/`;

export const username = production ? "zstUserId" : "startalkAPP";
export const password = production
  ? "zstS8dadj#32fskjf39034"
  : "DFSW2323R2E9F3IU";

export const gtmId = "GTM-5MMXNJ92";

export const AgoraAppId = production
  ? "cf68867950e1474e9db3437fef450321"
  : "4de2efedf5ee424da45367c1abdd4387";
